import { h } from 'preact';
import { useContext } from 'preact/hooks';
import { KBContext } from 'widget_main/store';

import Button from 'widget_main/components/Button/Button';
import { useTranslations } from 'i18n/hooks';
import globalMessages from 'widget_main/globals/messages';
import { getKustomerCore } from 'widget_main/globals/helpers';
import styles from './kbArticleSurveyRating.scss';

const kustomerCore = getKustomerCore();

const KBArticleSurvey = ({
  articleId,
  articleSurveyConfig,
  setSurveyResponse,
}) => {
  const kb = useContext(KBContext);
  const translations = useTranslations(globalMessages);
  const submitArticleFeedback = (feedback) => {
    setSurveyResponse('SENT');
    kustomerCore.submitArticleFeedback(feedback, setSurveyResponse);
  };
  return (
    <div>
      <div className={styles.articleSurveyRatingQuestion}>
        {articleSurveyConfig.ratingTitle}
      </div>
      <div>
        <Button
          className={styles.articleSurveyRatingButton}
          ariaLabel={translations.yes}
          type="button"
          variant="primary"
          onClick={() =>
            submitArticleFeedback({
              articleId,
              knowledgeBaseId: kb.config.id,
              rating: 'positive',
            })
          }
          data-kt="articleSurveyRatingYesButton"
        >
          {translations.yes}
        </Button>
        <Button
          className={styles.articleSurveyRatingButton}
          ariaLabel={translations.no}
          type="button"
          variant="primary"
          onClick={() =>
            submitArticleFeedback({
              articleId,
              knowledgeBaseId: kb.config.id,
              rating: 'negative',
            })
          }
          data-kt="articleSurveyRatingNoButton"
        >
          {translations.no}
        </Button>
      </div>
    </div>
  );
};

export default KBArticleSurvey;
